import axios from "@/api/axiosInstance";
import {
  FetchCatalogProductsRequest,
  FetchCatalogProductsResponse,
} from "./types";

export const fetchCatalogProducts = async (
  params: FetchCatalogProductsRequest,
  signal?: AbortSignal,
): Promise<FetchCatalogProductsResponse> => {
  const response = await axios.get<FetchCatalogProductsResponse>(
    "/api/private/product-catalog/products",
    { params, signal },
  );
  return response.data;
};
